import { Anchor } from "@mantine/core";
import { generatePath, Link } from "react-router";
import { ROUTES } from "../../../../routes";
import { TABS as ENERGY_DATA_VIEW_TABS } from "../../../EnergyData/EnergyDataView/EnergyDataView";
import { StatusSymbol, StatusSymbolColor } from "../../../Icons/StatusSymbol";

export enum DataAssessmentState {
  Sufficient = "ausreichend",
  NotSufficient = "nicht ausreichend",
  None = "-"
}

export function getAssessmentString(assessment: boolean | null) {
  if (assessment === true) {
    return DataAssessmentState.Sufficient;
  } else if (assessment === false) {
    return DataAssessmentState.NotSufficient;
  } else {
    return DataAssessmentState.None;
  }
}

export enum DataAssessmentAccessor {
  SiteDataAssessmentGridMakoMeter = "siteDataAssessmentGridMakoMeter",
  SiteDataAssessmentGeneratorSubMeter = "siteDataAssessmentGeneratorSubMeter"
}

interface DataAssessmentCellProps {
  projectId: string;
  assessment: boolean | null;
}

function DataAssessmentCell({
  projectId,
  assessment
}: DataAssessmentCellProps) {
  const energyDataPath = generatePath(ROUTES.energyData.entry, { projectId });
  const dataAvailabilityPath = `${energyDataPath}/${ENERGY_DATA_VIEW_TABS.TAB_ENERGY_DATA_AVAILABILITY}`;

  if (assessment === null) {
    return <span>-</span>;
  }

  const statusSymbolColor = assessment
    ? StatusSymbolColor.Green
    : StatusSymbolColor.Red;

  return (
    <>
      <StatusSymbol color={statusSymbolColor} />
      <Anchor component={Link} to={dataAvailabilityPath}>
        {getAssessmentString(assessment)}
      </Anchor>
    </>
  );
}

export { DataAssessmentCell };
